<!-- 大数据表格 -->
<template>
<basic-container>
  <div class="width-p100 bb-sm-primary mb-xxs pb-xs ds-fx flex-direction-row justify-content-start align-items-center">
    <i class="el-icon-document color-primary mr-sm"></i>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{path:colObj.parentPath,query:{runId:$route.query.runId,...this.colObj.parentQuery}}">{{colObj.parentName}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{colObj.name}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.query.sname}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <TreeTable ref="child" v-if="colObj.isTree===true"
    v-bind="$attrs"
    :colObj='colObj'></TreeTable>
  <DataTable ref="child" v-if="colObj.isTree===false"
    v-bind="$attrs"
    :colObj='colObj'></DataTable>
</basic-container>
</template>

<script>
import DataTable from '@/components/table/template/dataTable';
import TreeTable from '@/components/table/template/treeTable';
export default {
components: {
  DataTable,
  TreeTable,
},
props:{colObj:Object},
data() {
  return {};
},
computed: {},
watch: {},
//方法集合
methods: {},
created() {},
mounted() {},
activated() {},
}
</script>
<style lang='scss' scoped></style>